module.exports = __webpack_public_path__ + "img/fasting-prayer-sermons.3447feb2.jpeg";